module.exports = __webpack_public_path__ + "static/img/modeling3.7458ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling3.png
// module id = Hcx3
// module chunks = 2